<template>
  <div class="container">
    <div class="header-title">
      <el-button type="primary" size="mini" @click="moduleuploadDialog = true"
      >上传主客户端</el-button>
      <el-button type="primary" size="mini" @click="getClientAppList">刷新</el-button>
      <!--<el-badge class="mark" :value="modulesListByFilter.length || 0">-->
      <!--<el-tag type="success" size="mini">总计</el-tag>-->
      <!--</el-badge>-->
    </div>
    <vv-table
      :height="700"
      :config="tableConfig"
      :data="clientList">
      <template slot-scope="scope" slot="date_slot">
        {{scope.row.add_ts | tsToDate}}
      </template>
      <template slot-scope="scope" slot="state_slot">
        <el-tag type="danger" size="mini" v-if="scope.row.is_published === '0'">未发布</el-tag>
        <el-tag type="success" size="mini" v-else>已发布</el-tag>
      </template>
      <template slot-scope="scope" slot="event_slot">
        <!--<el-button type="text" size="mini">发布</el-button>-->
        <publishButton :moduleType="moduleType" :module_uuid="scope.row.version_uuid"
                       @completed="getClientAppList"></publishButton>
        &nbsp;&nbsp;
        <!--<el-button type="text" size="mini" @click="downLoad(url)">下载</el-button>-->
        <viewPublish :id="scope.row.version_uuid" v-if="scope.row.is_published === '1'"
                     :module-type="moduleType"></viewPublish>
        &nbsp;&nbsp;
        <el-button type="text" @click="copy(scope.row.url)" size="mini">复制链接</el-button>
      </template>
    </vv-table>
    <el-dialog
      title="主客户端信息"
      :visible.sync="moduleuploadDialog"
      width="600"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="moduleForm"
        label-width="100px"
      >
        <el-form-item
          label="客户端"
          v-model="moduleForm.module_zip_url"
          prop="module_zip_url"
        >
          <el-upload
            class="upload-demo"
            action=""
            :http-request="modelUpload"
            :before-upload="handleBeforeUpload"
            accept="zip"
            :limit="1"
            ref="clientUpload"
          >
            <el-button size="mini" type="primary">请上传客户端</el-button>
            <el-tag type="success" size="mini" v-if="uploading"><i class="el-icon-loading"></i>上传中</el-tag>
          </el-upload>
        </el-form-item>
        <el-form-item label="配置文件">
          <el-upload
            class="upload-demo"
            action=""
            :http-request="modelUpload"
            :before-upload="handleBeforeUpload"
            accept="json"
            :limit="1"
            ref="jsonUpload"
          >
            <el-button size="mini" type="primary">请上传package.json</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="软件版本" prop="module_version">
          <el-input
            size="mini"
            v-model="moduleForm.module_version"
            :disabled="true"
            placeholder="软件版本"
          ></el-input>
        </el-form-item>
        <el-form-item label="识别模块版本" prop="api_version">
          <el-input
            size="mini"
            v-model="moduleForm.api_version"
            :disabled="true"
            placeholder="识别模块版本"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本描述" prop="module_version_desc">
          <el-input
            size="mini"
            v-model="moduleForm.module_version_desc"
            :disabled="true"
            placeholder="版本描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            size="mini"
            v-model="moduleForm.module_desc"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUpload" size="mini">取 消</el-button>
        <el-button type="primary" @click="confirmUpload" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetClientAppList, apiUploadMainClient} from '@/api';
import md5 from 'js-md5';
import vvTable from 'vue-virtual-table';
import publishButton from './publishButton';
// import  from '';
import aliOSSUpload from '@/lib/aliOSSUpload';
import viewPublish from '_c/viewPublish';

export default {
  name: "",
  components: {
    vvTable,
    publishButton,
    viewPublish
  },
  data() {
    return {
      uploading: false,
      app_asar_info_list: [],
      moduleType: 1,
      rules: {
        module_zip_url: [{ required: true, message: "请上传主客户端" }],
        module_version: [{ required: true, message: "主客户端版本号不能为空" }],
        moduel_api_version: [
          { required: true, message: "识别模块版本号不能为空" }
        ]
      },
      moduleuploadDialog: false,
      moduleForm: {
        module_zip_md5: "",
        module_zip_url: "",
        module_setting_url: "",
        module_version: "",
        api_version: "",
        module_version_desc: "",
        module_desc: ""
      }
    };
  },
  mounted() {
    this.getClientAppList();
  },
  methods: {
    ...mapMutations(["setSubTitle", "set_api_version_list"]),
    download (url) {
      // util.download(url);
    },
    copy (text) {
      this.$copyText(text).then((e) => {
        this.$message.success('复制成功');
      }).catch((e) => {
        this.console.log(e);
        this.$message.error('复制失败' + e);
      });
    },
    async getClientAppList () {
      try {
        const {app_asar_info_list} = await apiGetClientAppList();
        this.app_asar_info_list = app_asar_info_list;
        this.set_api_version_list(app_asar_info_list.map(a => {
          return {
            value: a.api_version,
            version: a.api_version
          };
        }));
      } catch (e) {
        this.$message.error("获取主客户端列表失败" + e.message);
      };
    },
    async computedMd5(file) {
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      let that = this;
      fileReader.onload = async e => {
        let md5key = md5(e.target.result);
        console.log(md5key);
        that.moduleForm.module_zip_md5 = md5key;
        // return md5key;
      };
    },
    resetForm() {
      this.$refs["form"].resetFields();
      this.$refs['clientUpload'].clearFiles();
      this.$refs['jsonUpload'].clearFiles();
    },
    async confirmUpload() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return false;
        }
      });
      try {
        await apiUploadMainClient(this.moduleForm);
        this.$message.success("上传成功");
        this.cancelUpload();
        this.getClientAppList();
      } catch (e) {
        console.log(e);
        this.$message.error("上传失败" + e.message);
      }
    },
    cancelUpload() {
      this.moduleForm = {
        module_zip_url: "",
        module_version: "",
        moduel_api_version: "",
        module_version_desc: "",
        module_desc: ""
      };
      this.moduleuploadDialog = false;
      this.resetForm();
    },
    handleBeforeUpload(file) {
      if (file.type === "application/json") {
        // console.log(qs.stringify(file));
        const reader = new FileReader();
        reader.onload = e => {
          try {
            let json = JSON.parse(e.target.result);
            this.moduleForm.module_version_desc = json.versionDesc;
            this.moduleForm.api_version = json.api;
            this.moduleForm.module_version = json.version;
          } catch (e) {
            this.$message.error("package.json获取失败" + e.message);
          }
        };
        reader.readAsText(file);
      } else if (file.type.indexOf('zip') !== -1) {
        this.computedMd5(file);
      } else {
        this.$message.error('请上传zip或者Json文件');
      }
    },
    parserJson(file) {},
    async modelUpload(options) {
      let file = options.file;
      const type = file.type;
      if (type === "application/json") {
        this.$message.success("package.json上传成功");
      } else {
        this.uploading = true;
        // 上传module
        try {
          const { url } = await aliOSSUpload(
            {
              bucket: "zhiyan-app-upload",
              prefix: "zhiyan-app",
              name: file.name
            },
            file
          );
          this.$message.success("主客户端上传成功");
          this.moduleForm.module_zip_url = url;
          this.uploading = false;
        } catch (e) {
          console.log(e);
          this.uploading = false;
          this.$message.error(e.message);
        }
      }
      console.log(file);
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters([]),
    clientList () {
      return this.app_asar_info_list;
    },
    tableConfig() {
      return [
        { prop: "desc", name: "客户端备注" },
        { prop: "version", name: "客户端版本" },
        { prop: "version_desc", name: "更新日志" },
        { prop: "api_version", name: "识别模块版本" },
        { prop: "_action", name: "发布状态", actionName: "state_slot" },
        { prop: "_action", name: "更新日期", actionName: "date_slot" },
        { prop: "_action", name: "操作", actionName: "event_slot" }
      ];
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .header-title {
    position: absolute;
    top: -90px;
    left: 200px;
    z-index: 1000;
  }
}
</style>
